import React, { Component } from "react";
import AsyncComponent from "../../components/async-component";
import PageWrap from "../../components/page-wrap";
import PageContent from "../../components/page-content";
import { updateBreadcrumb } from "../../utils/breadcrumbs";
import { EquipmentsContextProvider } from "./context/equipments-context";

class EquipmentsPage extends Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <EquipmentsContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </EquipmentsContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default EquipmentsPage;
